import { useAuth } from "@stardeck/client-auth";
import { IframeWrapper } from "@stardeck/client-utils";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Footer } from "@/components/footer";
import { Header } from "@/components/header";
import { queryClient } from "@/lib/react-query";
import { About } from "@/pages/about";
import AuthTest from "@/pages/auth-test";
import { Contact } from "@/pages/contact";
import { Gallery } from "@/pages/gallery";
import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import { Workshops } from "@/pages/workshops";

function App() {
  const { mode } = useAuth();

  const content = (
    <div className="min-h-screen bg-background text-foreground">
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/auth-test" element={<AuthTest />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        {mode === "iframe" ? (
          <IframeWrapper>
            <Header />
            {content}
            <Footer />
          </IframeWrapper>
        ) : (
          <>
            <Header />
            {content}
            <Footer />
          </>
        )}
      </Router>
    </QueryClientProvider>
  );
}

export default App;
